import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectCostIT } from "../Model/ProposalProjectCostIT";

export async function getProposalProjectCostIT(idProposalProject) {
	let response = await getAPIResponse("/v1/proposal-project-cost-it/"+idProposalProject);
	if (response === null) {
		return null;
	}
	let proposalProjectCostIT = response.map(data => ProposalProjectCostIT.createFromResponseData(data));
	return proposalProjectCostIT;
}
